/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_StoreInputs */

const en_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to store`)
};

const es_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a la tienda`)
};

const fr_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à la boutique`)
};

const de_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Store`)
};

const ja_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアに戻る`)
};

const zh_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回店铺`)
};

const ar_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة إلى المتجر`)
};

const id_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke toko`)
};

const it_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna al negozio`)
};

const ru_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться в магазин`)
};

const pt_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar para a loja`)
};

const ko_back_to_store = /** @type {(inputs: Back_To_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어로 돌아가기`)
};

/**
* | output |
* | --- |
* | "Back to store" |
*
* @param {Back_To_StoreInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const back_to_store = /** @type {((inputs?: Back_To_StoreInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_StoreInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back_to_store(inputs)
	if (locale === "es") return es_back_to_store(inputs)
	if (locale === "fr") return fr_back_to_store(inputs)
	if (locale === "de") return de_back_to_store(inputs)
	if (locale === "ja") return ja_back_to_store(inputs)
	if (locale === "zh") return zh_back_to_store(inputs)
	if (locale === "ar") return ar_back_to_store(inputs)
	if (locale === "id") return id_back_to_store(inputs)
	if (locale === "it") return it_back_to_store(inputs)
	if (locale === "ru") return ru_back_to_store(inputs)
	if (locale === "pt") return pt_back_to_store(inputs)
	return ko_back_to_store(inputs)
});